import { OneToOneRawTextMessage, RawTextMessage } from "@/store/chats/types";
import { isOneToOneChat } from "@/firebase/utils";

export const getIsOneToOneRawTextMessage = (
  _: RawTextMessage,
  chatId: string,
): _ is OneToOneRawTextMessage => {
  return isOneToOneChat(chatId);
};
